import React, { useState } from 'react';
import { useStripe, useElements, IbanElement } from '@stripe/react-stripe-js';
import AuthService from '../../services/api/auth';

import IbanForm from './IbanForm';
import { emailIsValid } from '../../inputs/validations';
import LoadingModal from '../LoadingModal';

const SepaSetupForm = ({ history, clientSecret, onSetSepaData }) => {
    const stripe = useStripe();
    const elements = useElements();
    const [errors, setErrors] = useState([]);
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [isIbanComplete, setIsIbanComplete] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const isSubmitDisabled = () => {
        let isDisabled = false;
        if (!stripe) {
            isDisabled = true;
        }
        if (!name || !email) {
            isDisabled = true;
        }
        if (email && emailIsValid(email) === 'invalid') {
            isDisabled = true;
        }
        if (errors.length > 0) {
            isDisabled = true;
        }
        if (!isIbanComplete) {
            isDisabled = true;
        }

        return isDisabled;
    };

    const handleOnChangeIban = e => {
        setIsIbanComplete(e.complete);
        if (e.error) {
            // Store event.error.message in state and display it.
            if (window.VULOG_TRANSLATIONS[e.error.code]) {
                setErrors([e.error.code]);
            } else {
                setErrors([e.error.message]);
            }
        } else {
            setErrors([]);
        }
    };

    const handleSubmit = async event => {
        // We don't want to let default form submission happen here,
        // which would refresh the page.
        event.preventDefault();
        setIsLoading(true);

        if (!stripe || !elements) {
            // Stripe.js has not yet loaded.
            // Make sure to disable form submission until Stripe.js has loaded.
            return;
        }

        const iban = elements.getElement(IbanElement);

        const result = await stripe.confirmSepaDebitSetup(clientSecret, {
            payment_method: {
                sepa_debit: iban,
                billing_details: {
                    name,
                    email,
                },
            },
        });

        if (result.error) {
            // Show error to your customer.
            setErrors([result.error.message]);
            setIsLoading(false);
        } else {
            // Show a confirmation message to your customer.
            // The SetupIntent is in the 'succeeded' state.
            try {
                const response = await AuthService.stripeValidatePayment();
                const next = response.next || '/register/status';
                onSetSepaData({ paymentSuccess: true });
                history.push(next);
            } catch (error) {
                setErrors(['Your payment method is invalid. Please retry.']);
                setIsLoading(false);
            }
        }
    };

    return (
        <>
            <LoadingModal loading={isLoading} />
            <IbanForm
                onSubmit={handleSubmit}
                disabled={isSubmitDisabled()}
                errors={errors}
                setName={setName}
                setEmail={setEmail}
                handleOnChangeIban={handleOnChangeIban}
            />
        </>
    );
};

export default SepaSetupForm;
